import DataDisplayRowI from "../DataDisplayRowI";
import getVoucherRow from "../DataDisplayRow/VoucherRow";
import DataDisplayTable from "../DataDisplayTable";

class VoucherTable extends DataDisplayTable {
    #row!: DataDisplayRowI

    generateRow(): DataDisplayRowI {
        this.#row = getVoucherRow()
        return this.#row
    }
}

let voucherTable: VoucherTable | null = null;

export default function getVoucherTable(): VoucherTable {
    if (voucherTable === null)
        voucherTable = new VoucherTable()
    return voucherTable
}